import React from 'react';
import { Typography } from '@mui/material';
import ClientsMap from '../components/clients/ClientsMap';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo';

const Clients = () => {
  const { t } = useTranslation('experience');
  const title = `Betonoki - ${t('ourExperience', { defaultValue: 'Doświadczenie' })}`;
  const description =
    t('metaDescription', {
      defaultValue: 'Mapa doświadczenia zespołu Betonoki oraz wybrane realizacje i branże.',
    });

  return (
    <>
      <Seo title={title} description={description} path="/clients" />
      <Typography variant="h1" gutterBottom>
        Doświadczenie zespołu:
      </Typography>
      <ClientsMap />
    </>
  );
};

export default Clients;